import { setToLocalStorage } from 'utils/webStorage/localStorage'

import { LEGACY_TOKEN_KEY } from '../constants'

export const setLegacyToken = (token: string) => {
	setToLocalStorage(LEGACY_TOKEN_KEY, token)
}
